<template>
  <div class="main">
    <!-- 这里是pc版本的显示位置 -->
    <div class="title" v-if="isMobile()===false">
      <router-link class="element_div_def" v-for="(item, i) in navList"
       :key="i" :to="item.name" :id="'title' + i" v-on:click.native="onClick" tag="div">
        {{item.navItem}}
        </router-link>
    </div>
    <!-- 这里是手机版本显示的位置 -->
    <div class="navmenu" v-if="isMobile()===true">
      <span class="span_left">{{phoneBrands}}</span> <span id="navbutton" class="span_right_nav" @click="navbutton"></span>
      <ul v-show="isShowmenu">
         <router-link class="def_li" v-for="(item, i) in navList"
          :key="i" :to="item.name" :id="'title' + i" v-on:click.native="phoneOnClick" tag="li">
          {{item.navItem}}
        </router-link>
      </ul>
    </div>
    <div v-show="isShowmenu" class="mengpand"></div>

    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
import { uIsMobile } from './libs/utils.js'

export default {
  data () {
    return {
      navList: [
        { name: '/', navItem: '安卓通用' },
        { name: '/Huawei', navItem: '华为' },
        { name: '/Vivo', navItem: 'VIVO' },
        { name: '/Oppo', navItem: 'OPPO' },
        { name: '/Mi', navItem: '小米' },
        { name: '/Samsung', navItem: '三星' },
        { name: '/OnePlus', navItem: '一加' },
        { name: '/Meizu', navItem: '魅族' },
        { name: '/Lenovo', navItem: '联想' }
      ],
      currentActive: 'title0',
      isMobile: uIsMobile,
      logoImage: require('../public/logo.png'),
      buttonImage: require('../public/navBtn.png'),
      isShowmenu: false,
      phoneBrands: '安卓通用'
    }
  },
  mounted () {
    console.log('isMobile : ' + this.isMobile())
    if (this.isMobile() === false) {
      this.setActive(this.currentActive)
    }
  },
  methods: {
    navbutton () {
      const id = 'navbutton'
      const elem = document.getElementById(id)
      if (this.isShowmenu === false) {
        this.isShowmenu = true
        elem.className = 'span_right_close'
      } else {
        this.isShowmenu = false
        elem.className = 'span_right_nav'
      }
      this.setMobileActive(this.currentActive)
    },
    phoneOnClick (e) {
      const id = e.srcElement.id
      if (this.currentActive !== id) {
        this.setMobileDefault(this.currentActive)
        this.setMobileActive(id)
        this.currentActive = id
        this.navbutton()
        this.phoneBrands = this.navList[parseInt(id[5])].navItem
      }
    },
    onClick (e) {
      const id = e.srcElement.id
      if (this.currentActive !== id) {
        this.setDefault(this.currentActive)
        this.setActive(id)
        this.currentActive = id
      }
    },
    setDefault (id) {
      const elem = document.getElementById(id)
      elem.className = 'element_div_def'
      // elem.style.removeProperty('border-bottom')
      // elem.setAttribute('style', 'color: #999999')
    },
    setActive (id) {
      const elem = document.getElementById(id)
      elem.className = 'element_div_act'
      // elem.setAttribute('style', 'color: #191919')
      // elem.setAttribute('style', 'border-bottom: 3px ridge #579DFF')
    },
    setMobileDefault (id) {
      const elem = document.getElementById(id)
      elem.className = 'def_li'
    },
    setMobileActive (id) {
      const elem = document.getElementById(id)
      elem.className = 'def_li act_li'
    }
  }
}
</script>

<style>
.main{
  display: block;
  text-align: center;
  margin: 0 auto;
}
/* 手机端配置 */
.navmenu{
  position: absolute;
  top: 0%;
  right: 0%;
  width: 100%;
  height: 8%;
  background-color: #FFFFFF;
  z-index: 99;
}
.navmenu .span_right_nav{
  width: 1.2rem;
  height: 1.2rem;
  background: url('../public/navBtn.png') no-repeat;
  background-size: 1.2rem 2.4rem;;
  background-position: 0 0;
  margin-right: 6%;
  margin-top: 5.5%;
  float: right;
  display: block;
}
.navmenu .span_right_close{
  width: 1.2rem;
  height: 1.2rem;
  background: url('../public/navBtn.png') no-repeat;
  background-size: 1.2rem 2.4rem;
  background-position: 0 -1.2rem;
  margin-right: 6%;
  margin-top: 5.5%;
  float: right;
  display: block;
}
.navmenu .span_left{
  max-height: 100%;
  max-width: 100%;
  margin-top: 5%;
  margin-left: 6%;
  float: left;
  font-family: 'Microsoft YaHei',Helvetica;
  font-size: 18px;
  text-align: center;
}
.navmenu ul{
  padding: 0;
  margin: 2px;
  float: none;
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  display: block;
  background-color: #FFFFFF;
}
.navmenu ul .def_li{
  text-align: left;
  font-size: 12px;
  width: 87%;
  margin-left: 6%;
  margin: 3% 6%;
  height: 30px;
  list-style-type: none;
  list-style: none;
  border-bottom: 1px solid #e5e5e5;
  font-family: 'Microsoft YaHei',Helvetica;
}
.navmenu ul .act_li{
  color: #579DFF
}
.navmenu ul .link {
  text-decoration: none;
  margin: 0 10%;
  width: 100%;
}
.mengpand{
  background-color: black;
  position: absolute;
  display: block;
  text-align: center;
  top: 6%;
  right: 0%;
  width: 99%;
  height: 95%;
  z-index: 80;
  opacity: 0.3;
}

/* PC机配置 */
.title{
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0%;
  right: 0%;
  width: 100%;
  height: 5%;
  background-color: #E5E5E5;
}
.title .element_div_def{
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
  margin: 0 1%;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #999999;
  line-height: 24px;
  cursor: pointer;
  /* border-bottom: 3px ridge #579DFF; */
}
.title .element_div_act{
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
  margin: 0 1%;
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #191919;
  line-height: 24px;
  cursor: pointer;
  border-bottom: 3px solid #579DFF;
}
.content{
  position: absolute;
  display: block;
  text-align: center;
  background-color: #F5F9FB;
  top: 5%;
  right: 0%;
  width: 100%;
  height: 95%;
}
</style>
